function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useAuth } from '@/hooks/useAuth';
import { useState, Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Header from '@/layout/Header';
import Footer from '@/layout/Footer';
import AuthModal from '@/features/AuthModal/AuthModal';
import PageLoader from '@/ui/PageLoader';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MainPage = /*#__PURE__*/ lazy(function () {
    return import('@/pages/MainPage');
});
var GenresPage = /*#__PURE__*/ lazy(function () {
    return import('@/pages/GenresPage');
});
var GenreMoviesPage = /*#__PURE__*/ lazy(function () {
    return import('@/pages/GenreMoviesPage');
});
var MoviePage = /*#__PURE__*/ lazy(function () {
    return import('@/pages/MoviePage');
});
var AccountPage = /*#__PURE__*/ lazy(function () {
    return import('@/pages/AccountPage');
});
function App() {
    var _useAuth = useAuth(), user = _useAuth.user, loading = _useAuth.loading, isAuth = _useAuth.isAuth;
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), authView = _useState2[0], setAuthView = _useState2[1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [/*#__PURE__*/ _jsx(Header, {
                user: user,
                loading: loading,
                isAuth: isAuth,
                onLoginClick: function onLoginClick() {
                    return setAuthView('login');
                }
            }), /*#__PURE__*/ _jsx("main", {
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: /*#__PURE__*/ _jsx(PageLoader, {}),
                    children: /*#__PURE__*/ _jsxs(Routes, {
                        children: [/*#__PURE__*/ _jsx(Route, {
                                path: "/",
                                element: /*#__PURE__*/ _jsx(Navigate, {
                                    to: "/main",
                                    replace: true
                                })
                            }), /*#__PURE__*/ _jsx(Route, {
                                path: "/main",
                                element: /*#__PURE__*/ _jsx(MainPage, {
                                    onAuthRequired: function onAuthRequired() {
                                        return setAuthView('login');
                                    }
                                })
                            }), /*#__PURE__*/ _jsx(Route, {
                                path: "/genres",
                                element: /*#__PURE__*/ _jsx(GenresPage, {})
                            }), /*#__PURE__*/ _jsx(Route, {
                                path: "/genre/:genre",
                                element: /*#__PURE__*/ _jsx(GenreMoviesPage, {})
                            }), /*#__PURE__*/ _jsx(Route, {
                                path: "/movie/:id",
                                element: /*#__PURE__*/ _jsx(MoviePage, {})
                            }), /*#__PURE__*/ _jsx(Route, {
                                path: "/account",
                                element: /*#__PURE__*/ _jsx(AccountPage, {})
                            })]
                    })
                })
            }), /*#__PURE__*/ _jsx(Footer, {}), /*#__PURE__*/ _jsx(AuthModal, {
                view: authView,
                onChangeView: setAuthView,
                onClose: function onClose() {
                    return setAuthView(null);
                }
            })]
    });
}
export default App;
